import { flip, inline, offset, shift, type Placement } from '@floating-ui/dom';
import { injectService } from '@patsnap/tahiti-core';
import { useDisposes } from '@telecom/shared/composables/use-disposes';
import { FloatUIPositioningStrategy } from '@telecom/shared/services/popover/impls/positioning-strategies';
import { PopoverRegistry } from '@telecom/shared/services/popover/popover-registry';
import ClassificationPopover from './ClassificationPopover.vue';
import { createApp } from 'vue';
import { SafeHtmlPlugin } from '@telecom/shared/plugins/safe-html';

function positioningStrategy(reference: HTMLElement) {
    return new FloatUIPositioningStrategy({
        placement: (reference.dataset.tooltipPlacement as Placement) || 'bottom-start',
        middleware: [
            inline(),
            offset(4),
            flip({
                boundary: 'clippingAncestors',
                fallbackPlacements: ['bottom', 'right', 'left'],
            }),
            shift({
                boundary: 'clippingAncestors',
                padding: 5,
            }),
        ],
    });
}

function renderClassification(reference: HTMLElement) {
    let div = undefined;
    const app = createApp(ClassificationPopover, {
        type: reference.dataset.type as string,
        value: reference.dataset.typeValue as string,
    });

    app.use(SafeHtmlPlugin);

    return {
        mount() {
            div = document.createElement('div');
            app.mount(div);
            return div.firstChild as HTMLElement;
        },
        dispose() {
            div = undefined;
            app.unmount();
        },
    };
}

export function useClassification() {
    const popoverRegistry = injectService<PopoverRegistry>(PopoverRegistry);

    const { disposes } = useDisposes();

    disposes.push(
        popoverRegistry.register({
            selector: '[data-type="cpc"],[data-type="ipc"]',
            trigger: 'hover',
            render: renderClassification,
            positioningStrategy,
        }),
    );
}
